"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletErrors = void 0;
var WalletErrors;
(function (WalletErrors) {
    WalletErrors["NO_ACTIVE_ACCOUNT"] = "NO_ACTIVE_ACCOUNT";
    WalletErrors["NO_ACCOUNT_LOCAL_KEY"] = "NO_ACCOUNT_LOCAL_KEY";
    WalletErrors["INVALID_ACCESS_KEY"] = "INVALID_ACCESS_KEY";
    WalletErrors["NO_SIGNER_ACCOUNT_ID"] = "NO_SIGNER_ACCOUNT_ID";
    WalletErrors["REQUEST_NOT_SIGNED"] = "REQUEST_NOT_SIGNED";
    WalletErrors["NO_SIGNATURE"] = "NO_SIGNATURE";
    WalletErrors["INVALID_SIGNATURE"] = "INVALID_SIGNATURE";
    WalletErrors["OPERATION_FAILED"] = "OPERATION_FAILED";
})(WalletErrors || (exports.WalletErrors = WalletErrors = {}));
